export default __webpack_public_path__ + "static/media/CityLights05.bd26745f.jpg";